export const articleDefaultSorting = [
  {
    id: "publish_date",
    desc: true,
  },
];
